import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { AtividadeChecklistItemModule } from '../checklist-item';
import { AtividadeTipoPipeModule } from '../tipo/pipes';
import { TituloReceberFormModule } from '../../titulo-receber/form/titulo-receber-form.module';
import { UsuarioSelectModule } from '../../usuario/select';
import { PessoaSharedModule } from '../../pessoa/pessoa-shared.module';
import { PessoaContatoModule } from '../../pessoa/contato';
import { ClienteTypeaheadSharedModule } from '../../pessoa/cliente/typeahead/cliente-typeahead-shared.module';
import { LeadTypeaheadModule } from '../../crm/lead/typeahead';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ContatoIniciativaCardControlRadioModule } from '../../common/contato/inciativa/components/card-control-radio';
import { ContatoTipoSelectModule } from '../../common/contato/tipo/components/select';
import { ContatoFormaSelectModule } from '../../common/contato/forma/components/select';
import { MotivoPerdaVendaSelectModule } from '../../motivo-perda-venda/select';
import { AtividadeRetornoFormModule } from '../retorno/form';
import { AtividadeTipoSelectModule } from '../tipo/select';

import { AtividadeFormModalComponent } from './atividade-form-modal.component';


@NgModule({
    imports: [
        SharedModule,
        AtividadeChecklistItemModule,
        AtividadeTipoPipeModule,
        TituloReceberFormModule,
        UsuarioSelectModule,
        PessoaSharedModule,
        PessoaContatoModule,
        ClienteTypeaheadSharedModule,
        LeadTypeaheadModule,
        TimepickerModule,
        ContatoIniciativaCardControlRadioModule,
        ContatoTipoSelectModule,
        ContatoFormaSelectModule,
        MotivoPerdaVendaSelectModule,
        AtividadeRetornoFormModule,
        AtividadeTipoSelectModule
    ],
    declarations: [
        AtividadeFormModalComponent
    ],
    exports: [
        AtividadeFormModalComponent
    ]
})
export class AtividadeFormModalModule { }
